import { fetchTeamTable } from 'utils/';

const getApprovalTeam = async (accountId) => {
  const processedTeam = await fetchTeamTable(accountId);

  const approvalTeam = processedTeam.filter((user) =>
    ['Client', 'Client Admin', 'Super Admin'].includes(user.adminStatus),
  );

  const ectoTeam = await fetchTeamTable(process.env.REACT_APP_ECTO_ID);

  const combined = [...approvalTeam, ...ectoTeam];
  const uniqueMap = new Map();
  combined.forEach((user) => {
    if (!uniqueMap.has(user.id)) {
      uniqueMap.set(user.id, { value: user.id, label: user.name });
    }
  });

  return Array.from(uniqueMap.values());
};

export { getApprovalTeam };
